import React, {useState} from 'react'
import { useTranslation } from 'react-i18next';
import {MODELS} from "../../../../Apis/Models";
import {TABLES} from "../../../../Apis/Tables";
import {ACCESS_LOG_GET_DATA} from "../Model/Models";
import {DEFAULT_PAGINATION_LIST_SIZE, DEFAULT_PAGINATION_START} from "../../../../components/table/Model/TableModel";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const AccessLogModalApp = ({ userId }) => {
    const { t } = useTranslation();
    const moduleId = `${MODELS.UserAccessLog}`;
    const option = `${TABLES.USER_ACCESS_LOG_BY_USER}`;
    const [displayModal, setDisplayModal] = useState('');
    // The table keeps its request to itself, the export repeats it with the same
    // builder so both hit the model with the same criteria
    const body = ACCESS_LOG_GET_DATA.USER.buildBody({
        page: DEFAULT_PAGINATION_START,
        rowsPerPage: DEFAULT_PAGINATION_LIST_SIZE,
        id: userId,
        option,
    });

    return {
        t,
        moduleId,
        option,
        body,
        displayModal,
        setDisplayModal
    };
}

export default AccessLogModalApp
